// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3716":"7131a7edf3610cc7","3993":"cf3d3a6fe36911af","5000":"aba9d10cf4dd8e60","6648":"b864703eb9d5aeed","8223":"581b6ee20a8a9315","9236":"a0d60345c32bd1d4"}[chunkId] + ".js";
};